<template>
    <div @click="onClick"
        :class="[props.variant, '.cards-content', ishorizontal ? '.cards-horizontal' : '.cards-vertical']" tabindex="0"
        role="button" aria-label="Card de {{ props.title }}">
        <img width="auto" height="auto" v-if="props.icon" :class="[ishorizontal && '.cards-contentIconHorizontal', '.cards-contentIcon']"
            :src="props.icon" alt="icon" aria-label="Icono de guía">
        <div class=".cards-contentText">
            <h3 :class="'.cards-' + props.variant + 'Title'" role="header" :aria-label="props.title">{{ props.title }}
            </h3>
            <p :class="'.cards-' + props.variant + 'Text'">{{ props.text }}</p>
        </div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';
const props = defineProps({
    variant: {
        type: String,
        default: 'primary'
    },
    title: {
        type: String,
        default: ''
    },
    text: {
        type: String,
        default: ''
    },
    icon: {
        type: String,
        default: ''
    },
    ishorizontal: {
        type: Boolean,
        default: false
    }
})

</script>

<style>
.cards-content {
    cursor: pointer;
}

.cards-horizontal {
    display: grid;
    grid-template-columns: 0fr 1fr;
}

.cards-vertical {
    text-align: center;
    border: solid 1px rgba(0, 0, 0, .1) !important;
    border-radius: 0.3rem !important;
    box-shadow: 1px 3px 5px rgba(0, 0, 0, .1) !important;
}

.cards-content:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.02);
    transition: background-color 0.3s ease, transform 0.3s ease;
    transform: scale(1.002);
}

.cards-primary {
    border: solid 1px rgba(0, 0, 0, .1);
    border: 1px solid #007A5E;
    border-radius: 0.3rem;
    box-shadow: 1px 3px 5px rgba(0, 0, 0, .1);
    padding: 0.5rem;
}

.cards-secondary {
    border: solid 1px rgba(0, 0, 0, .1);
    border: 1px solid #F68B1F;
    border-radius: 0.3rem;
    padding: 0.5rem;
    box-shadow: 1px 3px 5px rgba(0, 0, 0, .1);
}

.cards-primaryTitle {
    font-family: Arial, sans-serif;
    font-size: 14px;
    color: #007A5E;
    margin: 0;
}

.cards-primaryText {
    margin: 0;
    font-size: 12.6px;
    font-family: Arial, sans-serif;
    color: #007A5E;
    font-weight: bold;
}

.cards-secondaryTitle {
    font-family: Arial, sans-serif;
    font-size: 14px;
    color: #F68B1F;
    margin: 0;
}

.cards-secondaryText {
    margin: 0;
    font-size: 12.6px;
    font-family: Arial, sans-serif;
    color: #F68B1F;
    font-weight: bold;
}

.cards-contentIcon {
    width: 40px;
    align-self: center;
}

.cards-contentIconHorizontal {
    margin-right: 10px;
}

.cards-contentText {
    align-self: center;
}
</style>